import { Button } from '@design-system';
import { useAnalyticsEmitter } from '@utils/analytics/emitter';

import { DrawWithFrames } from '../../../../features/draws/types';

type Props = {
  checkoutLink: string | null;
  entered: boolean;
  label: string;
  mainDraw: DrawWithFrames;
  successLabel: string;
};

/**
 * Entering a draw or applying for a pre-order happens in the checkout. With
 * no checkout link the draw is either entered already or closed.
 */
export const DrawEntryButton = ({
  checkoutLink,
  entered,
  label,
  mainDraw,
  successLabel,
}: Props) => {
  const [emitter] = useAnalyticsEmitter();

  if (checkoutLink) {
    return (
      <Button
        as="a"
        fullWidth
        href={checkoutLink}
        label={label}
        onClick={() => {
          emitter('draw entry', 'clicked', {
            'product title': mainDraw.product.title,
            'artist name': mainDraw.product.artists[0]?.name ?? '',
            'product price': mainDraw.product.price,
          });
        }}
        size="lg"
        variant="primary"
      />
    );
  }

  if (entered) {
    return (
      <Button
        disabled
        fullWidth
        icon="ic_check"
        label={successLabel}
        size="lg"
        variant="positive"
      />
    );
  }

  return (
    <Button disabled fullWidth label={label} size="lg" variant="primary" />
  );
};
